import http from 'conversations-http/clients/http';
export const deleteSpaceClient = ({
  id
}) => {
  return http.delete(`hd-spaces/v1/spaces/${id}`);
};